import React from 'react'

import { Icon } from '../../../../src/ui/icons/Icon.jsx'

const PinnedIcon = () => {
  return (
    <Icon id="bluedot.enabled" height={50} width={50} data-cy={'PinnedLocationIcon'}/>
  )
}
export default PinnedIcon
